import * as React from "react"
import { Skeleton } from "@mui/material"
import { AmchartSeeker } from "@ui-seeker/core"

import { TitleWithPopover } from "@components"
import { GROUPED_BY } from "@constants"
import { useCatalogueAnalyzerNumProductsSiteChart } from "./@hooks"
import { catalogueAnalyzerTabSelected } from "../@signals"


export default function CatalogueGeneralNumProducstSiteChart() {
	const { isLoading, data, chartKeys, title } = useCatalogueAnalyzerNumProductsSiteChart()
	
	if (isLoading) return <Skeleton variant="rectangular" height={500} />
	if (!data.length) return <></>

	return <AmchartSeeker
		rootID="productInsight"
		title={<TitleWithPopover title={title} />}
		data={data}
		series={chartKeys.map(key => ({
			name: key,
			yField: key,
			valueYShow: "valueYTotalPercent",
			xField: "retailer",
			type: 'column',
			stacked: true
		}))}
		chartProps={{
			chart: {
				maxTooltipDistance: 0,
			},
			legend: catalogueAnalyzerTabSelected.value === GROUPED_BY.CATEGORY ? { hidden: true } : {},
			xAxis: {
				categoryField: 'retailer'
			},
			yAxis: {
				min: 0,
				max: 100,
				numberFormat: "#'%'",
				strictMinMax: true,
				calculateTotals: true
			}
		}}
	/>
}
